import Price from '../../Price'
import {
  ProductName,
  PriceDetail,
  PricePerUnit,
  ProductDetails,
  ProductQuantityWrapper,
  SummaryHeading
} from '../SummaryList.styles'
import { SummaryListGroupProps } from '../SummaryList.types'
import {
  SummaryGroupItemContainer,
  SummaryGroupWrapper,
  SummaryGroupHeader,
  GroupProductsSubtitle
} from './SummaryListGroup.style'
import { ItemUnitDescription } from '../SummaryListItem/SummaryListItem.style'
import { IProduct } from '../../../../interfaces/catalog'
import { getCartLabels } from '../../../../utils/getCartLabels'
import { getTotalDiscounts, getTotalItems } from '../SummaryList.utils'
import SummaryHeader from '../SummaryHeader/SummaryHeader'
import { getPricePerPackageType } from '../../ItemCard/ItemCard.utils'
import { getQtyPerPackageType } from '../../../../utils'

const SummaryListGroup = (props: SummaryListGroupProps) => {
  const {
    headers = [],
    group,
    priceProps,
    labelMap,
    unitsLabelProps,
    unitsLabel = '{count} products',
    fieldsToDisplay,
    packagePriceMap = {}
  } = props
  const { groupBy, items } = group

  return (
    <SummaryGroupWrapper>
      <SummaryGroupHeader key={`header-group-${groupBy}`}>
        <SummaryHeading value={getCartLabels(groupBy, labelMap).label} />
        <GroupProductsSubtitle
          {...unitsLabelProps}
          value={unitsLabel.replace('{count}', String(getTotalItems(items)))}
        />
      </SummaryGroupHeader>
      <SummaryHeader headers={headers} />
      {items?.map((item: IProduct, index: number) => {
        const itemKey = item.id || item.sku || `itemGroup-${index}`
        const description = item.description || ''
        const packagePrice = getPricePerPackageType(item, packagePriceMap)
        const finalItemQty = getQtyPerPackageType(
          item.quantity,
          item.packageType
        )
        const totalizedPrice = (packagePrice ?? 0) * finalItemQty
        const showProductFee = fieldsToDisplay?.includes('totalFee')

        return (
          <SummaryGroupItemContainer key={itemKey}>
            {fieldsToDisplay?.includes('quantity') && (
              <ProductQuantityWrapper className="ProductQuantity">
                {finalItemQty}
              </ProductQuantityWrapper>
            )}
            <ProductDetails className="ProductDetails">
              {fieldsToDisplay?.includes('name') && (
                <ProductName>{item.name}</ProductName>
              )}
              {fieldsToDisplay?.includes('description') && (
                <ItemUnitDescription
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
              {fieldsToDisplay?.includes('unitPrice') && (
                <PricePerUnit value={packagePrice} {...priceProps} />
              )}
            </ProductDetails>
            <PriceDetail>
              <Price
                wrapContent
                discountOrder={1}
                priceOrder={2}
                value={totalizedPrice}
                fee={showProductFee ? item.totalFee : undefined}
                discount={getTotalDiscounts(
                  item.promotion?.value,
                  item.quantity
                )}
                {...priceProps}
              />
            </PriceDetail>
          </SummaryGroupItemContainer>
        )
      })}
    </SummaryGroupWrapper>
  )
}

export default SummaryListGroup
